import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    techDom: `${APP_CONFIG.care_cluster}/document-api/contrato_traslado_v2`,
  },
}
